// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_s6-0";